import { render } from "./footerCom.vue?vue&type=template&id=648a2f8d&scoped=true"
import script from "./footerCom.vue?vue&type=script&lang=js"
export * from "./footerCom.vue?vue&type=script&lang=js"

import "./footerCom.vue?vue&type=style&index=0&id=648a2f8d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-648a2f8d"]])

export default __exports__